export default __webpack_public_path__ + "static/media/noimage.e9c79467.png";